import dynamic from 'next/dynamic'

import Loader from '~lib/ui-kit/Loader'
import Modal from '~lib/ui-kit/Modal'
import Flex from '~shared/ui/Flex'

const SendForApprovalModalContent = dynamic(() => import('./SendForApprovalModalContent'), {
  loading: () => (
    <Flex align="center" justify="center">
      <Loader />
    </Flex>
  ),
})

interface SendForApprovalModalProps {
  assetId: string
  opened: boolean
  onClose: () => void
}

function SendForApprovalModal({ assetId, opened, onClose }: SendForApprovalModalProps) {
  return (
    <Modal size="m" overlayVariant="blur" opened={opened} onOverlayClick={onClose} onEscapePress={onClose}>
      <SendForApprovalModalContent assetId={assetId} onClose={onClose} />
    </Modal>
  )
}

export default SendForApprovalModal
